export default "__VITE_ASSET__B9rnof1z__"